import { gql } from '@apollo/client';

export const OrganizationFragment = gql`
  fragment Organization on Organization {
    id
    photoUrl
    name
    isAccountingFirm
    members {
      id
      email
      fullName
      companyScopes {
        id
        companyId
        scope
      }
      organizationScope
    }
    invitedMembers {
      id
      email
      scope
      expiresAt
      revokedAt
      acceptedAt
      derivedState
    }
  }
`;
